import { createFileRoute } from '@tanstack/react-router';
import { NecessidadePage } from '@/components/plano';

export const Route = createFileRoute('/_app/plano/necessidade')({
  component: NecessidadeRota,
});

function NecessidadeRota() {
  return <NecessidadePage />;
}
